import { MaxBrainAudience } from 'app/library/audience/models/audience.model';
import { HeaderBannerStream } from 'app/library/experience/models/header-banner-stream.model';
import { Posting } from 'app/library/posting/models/posting.model';
import { IExperienceWidgetContentQuery } from '../interfaces/experience-widget-content.interface';

// @dynamic
export class ExperienceWidgetContent {
    id: string;
    name: string;
    type: string;
    maxVisibleLength: number;
    header_stream: HeaderBannerStream;
    content: {
        id: string;
        posting: Posting;
        priority: string;
        startDate: string;
        endDate?: string;
        audience: MaxBrainAudience;
    }[];

    constructor(query?: IExperienceWidgetContentQuery) {
        if (query) {
            this.id = query.id.toString();
            this.name = query.name;
            this.type = query.type;
            this.maxVisibleLength = query.max_visible_length;
            this.content = query.content.map((experienceWidget) => {
                return {
                    id: experienceWidget.id.toString(),
                    posting: new Posting(experienceWidget.posting),
                    priority: experienceWidget.priority,
                    startDate: experienceWidget.start_date,
                    endDate: experienceWidget.end_date,
                    audience: new MaxBrainAudience(experienceWidget.audience),
                };
            });
        }
    }
}
